@if (partnerModel && partnerModel.vornameOderName2 && partnerModel.nachnameOderName1) {
    <div class="gridContainer dataGrid">
        <div class="row">
            <div class="cell grid-50">
                @if (!partnerModel.rechtsfaehigkeitType.value || partnerModel.rechtsfaehigkeitType.value === 'NATUERLICHE_PERSON') {
                    <span class="label">Name</span>
                }
                @if (partnerModel.rechtsfaehigkeitType.value && partnerModel.rechtsfaehigkeitType.value === 'JURISTISCHE_PERSON') {
                    <span class="label">Unternehmen</span>
                }
                <span class="value">{{ partnerModel.vornameOderName2.value }} {{ partnerModel.nachnameOderName1.value }}</span>
            </div>
            <div class="cell grid-50">
                <span class="label">Telefonnummer</span>
                @if (partnerModel.telefonnummer) {
                    <span class="value">{{ partnerModel.telefonnummer.value }}</span>
                }
            </div>
        </div>
        <div class="row">
            <div class="cell grid-50">
                <span class="label">Anschrift</span>
                @if (partnerModel.anschriftAllgemein.value.anschriftType === 'ANSCHRIFT_HAUS') {
                    <div>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.strasse }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.plz }} {{ partnerModel.anschriftAllgemein.value.ort }} {{ partnerModel.anschriftAllgemein.value.ortZusatz }}</span>
                    </div>
                }
                @if (partnerModel.anschriftAllgemein.value.anschriftType === 'ANSCHRIFT_POSTFACH') {
                    <div>
                        <span class="value">Postfach {{ partnerModel.anschriftAllgemein.value.postfach }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.plz }} {{ partnerModel.anschriftAllgemein.value.ort }} {{ partnerModel.anschriftAllgemein.value.ortZusatz }}</span>
                    </div>
                }
                @if (partnerModel.anschriftAllgemein.value.anschriftType === 'ANSCHRIFT_GROSSKUNDEN') {
                    <div>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.plz }} {{ partnerModel.anschriftAllgemein.value.ort }} {{ partnerModel.anschriftAllgemein.value.ortZusatz }}</span>
                    </div>
                }
                @if (partnerModel.anschriftAllgemein.value.anschriftType === 'ANSCHRIFT_AUSLAND') {
                    <div>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile1 }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile2 }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile3 }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile4 }}</span>
                    </div>
                }
                @if (partnerModel.anschriftAllgemein.value.anschriftType === 'ANSCHRIFT_AUSLAND_STRUKTURIERT') {
                    <div>
                        <span class="value">Postfach {{ partnerModel.anschriftAllgemein.value.strasse }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.plz }} {{ partnerModel.anschriftAllgemein.value.ort }}</span>
                        <span class="value">{{ partnerModel.anschriftAllgemein.value.nationSchluessel }} {{ partnerModel.anschriftAllgemein.value.nationText }}</span>
                    </div>
                }
            </div>
            <div class="cell grid-50">
                <span class="label">E-Mail</span>
                @if (partnerModel.email) {
                    <span class="value">{{ partnerModel.email.value }}</span>
                }
            </div>
        </div>
    </div>
}
